import { GraphQLResult } from '@aws-amplify/api-graphql';
import { logger } from '@jonni/utils/logger';
import { navigate } from 'gatsby';
import { API } from 'src/helpers';
import { onboardingStatusToScreenName } from 'src/layouts/components/NavigateToActiveScreen';
import { getRoutePath } from 'src/recoil/steps/atoms';
import { OnboardingStatus, Query } from 'src/shared/graphql/appsync.full';

const getUserQuery = /* GraphQL */ `
  query getUser {
    getUser {
      onboardingStatus
    }
  }
`;

export async function checkAndGoToCurrentScreen(currentScreen: OnboardingStatus) {
  let onboardingStatus = null;
  try {
    const res = (await API.graphql({ query: getUserQuery })) as GraphQLResult<{ getUser: Query['getUser'] }>;
    onboardingStatus = res?.data?.getUser?.onboardingStatus;
    if (onboardingStatus && onboardingStatus !== currentScreen) {
      const activeStep = onboardingStatusToScreenName(onboardingStatus);
      await navigate(getRoutePath(activeStep));

      logger.info('Current screen does not match the onboarding status, redirecting user', {
        currentScreen,
        onboardingStatus,
      });
      return;
    }
  } catch (err) {
    logger.error('Error while trying to fetch a current screen', {
      error: err,
      onboardingStatus,
      currentScreen,
    });
    return true;
  }

  return true;
}
